


















// Composition
import { defineComponent, useRouter, ref, Ref, watch } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

// Store
import { useSearchStore } from '~/store/search'

// Composables
import useSearch from '@/composables/search/useSearch'
import useSearchUrl from '@/composables/search/useSearchUrl'

// Components
import AppliedFacet from '@/components/feature/search/facets/FacetsAppliedInner.vue'
import FilterIconSVG from '@/assets/images/filter.svg?inline'

// Types
import { AppliedFacetInterface, CheckedFacetsInterface } from '@/types/search/searchTypes'

export default defineComponent({
  name: 'FacetsApplied',

  components: {
    AppliedFacet,
    FilterIconSVG,
  },

  setup() {
    const { facets } = storeToRefs(useSearchStore())
    const { setDefaultSearchSettings } = useSearch()
    const { getSearchUrl } = useSearchUrl()
    const router = useRouter()
    const appliedFacetList: Ref<Array<AppliedFacetInterface>> = ref([])

    // create one list of all applied facets
    const getAppliedFacetList = () => {
      appliedFacetList.value = []
      facets.value.checkedFacets.forEach((facet: CheckedFacetsInterface, index: number) => {
        Object.keys(facet).forEach((facetName) => {
          // exclude status
          if (facetName === 'status') {
            return
          }
          facets.value.checkedFacets[index][facetName].forEach((facetValue: string) => {
            appliedFacetList.value.push({
              key: facetName,
              value: facetValue,
            })
          })
        })
      })

      return appliedFacetList.value
    }

    // Listen to a change in checkedFacets and then get the applied list
    watch(
      facets,
      () => {
        getAppliedFacetList()
      },
      {
        immediate: true,
        deep: true,
      }
    )

    const showAppliedFacets = () => {
      return facets.value.checkedFacets.length > 0
    }

    // Delete all applied facets
    const clearAll = () => {
      appliedFacetList.value = []

      // back to default settings
      setDefaultSearchSettings(true)

      // Perform a new search
      router.push(getSearchUrl())
    }

    return {
      clearAll,
      showAppliedFacets,
      appliedFacetList,
      getAppliedFacetList,
    }
  },
})
